// extracted by mini-css-extract-plugin
module.exports = {"box":"NewAppeals_box__3f2C8","wrap":"NewAppeals_wrap__2j84Q"};